module.exports = __webpack_public_path__ + "img/logo.70850ccb.png";